/* global angular, $
 */
angular.module('ua5App')
    .directive('resourceContactform', ['$state', '$timeout', '$rootScope', '$sce', 'FormsFactory', function($state, $timeout, $rootScope, $sce, FormsFactory) {
        return {
            restrict: 'A',
            templateUrl: 'components/resource-contactform/resource-contactform.html',
            scope: {
                sectionIndex: '@',
                contentTitle: '@'
            },
            link: function($scope, element, attrs) {
                $scope.inputFocus = {};
                $scope.inputFocus.name = false;
                $scope.inputFocus.address = false;
                $scope.inputFocus.email = false;
                $scope.inputFocus.phone = false;
                $scope.inputFocus.message = false;

                $('.resource-connectform', element).find('label:not(".resources-connectform__label-long")').each(function() {
                    var w = $(this).width();
                    $(this).next().css('text-indent', w + 20 + 'px');
                });

                $('label', element).click(function() {
                    var labelID = $(this).attr('for');
                    $('#' + labelID).trigger('click');
                });

                $scope.submitContact = function() {

                    var cForm = $scope.contactForm;

                    if ($scope.contactForm.$invalid) {
                        alert('Please fill in the required fields above in the proper format.');
                    } else {
                        console.log('submit form logic here');
                        FormsFactory.appointment({
                            name: cForm.name.$modelValue,
                            email: cForm.email.$modelValue,
                            phone: cForm.phone.$modelValue,
                            message: cForm.message.$modelValue
                        }).then(function(response) {
                            if (response.data && response.data.Errors) {
                                // error handling
                                alert(response.data.Errors.join('\n'));
                            } else if (response.data) {
                                // success;
                                alert('Thank you for requesting an appointment!');
                                $('.hasForm .openFormLink', element).click();
                            } else {
                                // unknown error
                                alert('An error occured, please try submitting your form again.');
                            }
                        });
                    }
                };

                $timeout(function() {
                    $rootScope.$broadcast('resourceComponentPosition', {sectionIndex: $scope.sectionIndex});
                });
            }
        };
    }])
;
